import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p393718903031656448',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
